import React, { useState } from "react";

import { useQueryClient } from "@tanstack/react-query";

import { confirmFieldRedzones } from "services";

import { useCancelAsyncOnUnmount, useTranslation } from "utils";

import { GET_FIELDS } from "consts";

import { FieldListField } from "models";

import { Button, Drawer, Message as message } from "components";

import { FieldSelectionList } from "pages/app/fields/components/FieldSelectionList";

type RedzoneConfirmationDrawerProps = {
  fields: FieldListField[];
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const RedzoneConfirmationDrawer = ({ fields, visible, onClose, onConfirm }: RedzoneConfirmationDrawerProps) => {
  const { t } = useTranslation("farm");
  const queryClient = useQueryClient();

  const [loading, setLoading] = useState<boolean>(false);
  const [selectedFields, setSelectedFields] = useState<string[]>([]);

  const signal = useCancelAsyncOnUnmount()();

  const handleClose = () => {
    setSelectedFields([]);
    setLoading(false);
    onClose();
  };

  const handleRedzoneConfirmation = () => {
    setLoading(true);

    confirmFieldRedzones({
      ids: selectedFields,
      signal,
    })
      .then(() => {
        queryClient.invalidateQueries({ queryKey: [GET_FIELDS] });
        onConfirm();
      })
      .finally(() => {
        message({ content: t("redzoneDrawer.redzonesUpdated") });
        handleClose();
      });
  };

  return (
    <>
      <Drawer
        className="redzone-drawer"
        footer={
          <Button block disabled={loading} loading={loading} onClick={handleRedzoneConfirmation} type="primary">
            {t("redzoneDrawer.confirm")}
          </Button>
        }
        title={t("redzoneDrawer.title")}
        visible={visible}
        onClose={handleClose}
      >
        <p className="margin-bottom-200">{t("redzoneDrawer.explainer")}</p>
        <FieldSelectionList fields={fields} isFieldSelectable={() => true} selectedFields={selectedFields} setSelectedFields={setSelectedFields} />

        <div className="margin-bottom-250" />
      </Drawer>
    </>
  );
};
